import { Workbox } from "workbox-window";

let wb;

if ("serviceWorker" in navigator) {
  wb = new Workbox(`/service-worker.js`);

  wb.addEventListener("controlling", () => {
    window.location.reload();
  });
if(window.location.hostname != 'localhost')
  {
  wb.register();
  }

} else {
  wb = null;
}

export default wb;



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js